import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { contact } from '../../services/userServices';
import PageHeader from './../Common/PageHeader';
import './ContactPage.css';
const ContactPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const onSubmit = (formData) => {
    setIsLoading(true);
    contact(formData)
      .then((response) => {
        if (response && response.data.status === false) {
          const errorMessages = response.data.data.map((error) => {
            return error;
          });
          toast.error(errorMessages.join(', '));
        } else if (response && response.data.status === true) {
          toast.success('Contact Message Send Succesfully');
          reset();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        toast.error('An error occurred while sending message.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <>
      <Helmet>
        <title>Our Stellar Services Are Available All the Time </title>
        <meta
          name="keywords"
          content="creative items,unique items,creative items to sell,creative craft items,creative gift items,creative home decor products,unique home accessories,best home decor gifts,unique kitchen decor,unique modern home decor,unique decorative items,unique house accessories,cheap home decor gifts,unique kitchen products,unique kitchenware itemsunique kitchen items,home and kitchen unique products,unique kitchen accessories,unique kitchen tools"
        />
        <meta
          name="description"
          content="Contact us through the given details if you have any complaints about our unique home products. Our team is available to assist you with any query you might have."
        />
      </Helmet>
      <PageHeader title="Contact Us" />
      <div className="container-fluid contact-section">
        <div className="row align-items-start py-2">
          {/* Left Contact Info */}
          <div className="col-lg-6 mb-5 mb-lg-0">
            <h3 className="section-title">Send us a message</h3>
            <hr className="w-header" />
            <p className="section-description">
              Get in touch with us today or visit our website to choose
              <strong> unique decorative items </strong> for yourself.
            </p>

            <div className="row g-3">
              {/* Phone */}
              <div className="col-md-6">
                <a
                  href="tel:03459403395"
                  className="info-card"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="icon">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <h5>Phone</h5>
                    <p>03459403395</p>
                  </div>
                </a>
              </div>

              {/* WhatsApp */}
              <div className="col-md-6">
                <a
                  href="https://wa.me/+923459403395"
                  className="info-card"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="icon">
                    <i className="fa-brands fa-square-whatsapp"></i>
                  </div>
                  <div>
                    <h5>Whatsapp</h5>
                    <p>03459403395</p>
                  </div>
                </a>
              </div>

              {/* Email */}
              <div className="col-md-6">
                <a
                  href="mailto:support@bakumia.pk"
                  className="info-card"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div>
                    <h5>Email</h5>
                    <p>support@bakumia.pk</p>
                  </div>
                </a>
              </div>

              {/* Working Hours */}
              <div className="col-md-6">
                <div className="info-card">
                  <div className="icon">
                    <i className="fa-solid fa-clock"></i>
                  </div>
                  <div>
                    <h5>Working Hours</h5>
                    <p>Available 24/7</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-img d-none d-lg-block"></div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-6">
            <div className="box">
              {/* <h3 className="heading text-center">SEND US A MESSAGE</h3> */}
              <form
                className="mb-4"
                id="contactForm"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="form-group mb-3">
                  <label>Full Name</label>
                  <input
                    placeholder="User Name"
                    type="text"
                    className="form-control"
                    {...register('name', { required: true })}
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Email</label>
                  <input
                    placeholder="username@gmail.com"
                    type="text"
                    className="form-control"
                    {...register('email', {
                      required: true,
                      maxLength: 40,
                      pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    })}
                  />
                  {errors.email && (
                    <p className="text-danger">Please enter a valid email.</p>
                  )}
                </div>

                <div className="form-group mb-3">
                  <label>Phone</label>
                  <input
                    placeholder="03032112321"
                    type="number"
                    className="form-control"
                    {...register('phone', {
                      required: true,
                      pattern: /^03\d{9}$/,
                    })}
                  />
                  {errors.phone && (
                    <p className="text-danger">
                      Please enter a valid phone number starting with 03.
                    </p>
                  )}
                </div>

                <div className="form-group mb-3">
                  <label>Subject</label>
                  <input
                    placeholder="Subject..."
                    type="text"
                    className="form-control"
                    {...register('subject', { required: true })}
                  />
                </div>

                <div className="form-group mb-4">
                  <label>Message</label>
                  <textarea
                    placeholder="write your message here..."
                    className="form-control"
                    rows="5"
                    {...register('message', { required: true })}
                  ></textarea>
                </div>

                <button type="submit" className="submit_button w-100">
                  {isLoading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactPage;
